import React, { useContext, useEffect, useState } from 'react'
import { appContext } from '../../App'
import CheckForLink from './CheckForLink'

const PostCaption = ({ caption, postLink }) => {
  const { location } = useContext(appContext)

  const [inPostView, setInPostView] = useState(location.pathname.includes("posts"))


  useEffect(() => {
    setInPostView(location.pathname.includes("posts"))
  }, [location])

  return (
    <CheckForLink textToCheck={caption} otherLink={postLink}
      num={inPostView ? 10000000000 : 300}
    />
  )
}

export default PostCaption